import { StyleSheet } from 'aphrodite/no-important';

import screens from '../../identity/screenSizes';

export default StyleSheet.create({
  container: {
    width: '100%',
    display: 'flex',
    backgroundColor: '#ffffff',

    [screens.MOBILE]: { flexDirection: 'column' },
  },

  image: {
    height: 0,
    position: 'relative',
    paddingTop: '48.6%',
    flex: 1,
    [screens.MOBILE]: { paddingTop: '100%' },
    transition: 'opacity 300ms ease-out, transform 300ms ease-out;',
    opacity: 0,
    transform: 'translateY(20px)',

  },

  animate: {
    opacity: 1,
    transform: 'translateY(0)',
  },

  imgLeft: {
    flex: 1,
    marginRight: 13,
    paddingTop: "50%",

    [screens.MOBILE]: {
      marginRight: 0,
      paddingTop: '100%',
    },
  },

  imgRight: {
    flex: 1,
    paddingTop: "50%",

    [screens.MOBILE]: {
      paddingTop: '100%',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/MediaSplit/styles.js